import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../services/settings.service';

@Component({
  selector: 'app-main-shell',
  templateUrl: './main-shell.component.html',
  styleUrls: ['./main-shell.component.scss']
})
export class MainShellComponent implements OnInit {

  environmentSetting: string;


  constructor(
    private settingsService: SettingsService
  ) {
    this.settingsService.getEnvironment().subscribe(res => {
      if (res?.environment) {
        this.environmentSetting = res?.environment;
      }
    });
  }

  ngOnInit(): void {
  }

}
